import { useState, useEffect, useContext } from 'react';
import { useLocation } from 'react-router';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import UserContext from '../../../Context/user/userProvider';

function usePassengerInformationForm() {
  const { userDetail, userToken, loadingContext, setUserDetail, setUserToken  } = useContext(UserContext);
  const navigate = useNavigate();
  const location = useLocation().state;
  const [step, setStep] = useState(1);
  const [loadingScreen, setLoadingScreen] = useState(false);
  const [needLogin, setNeedLogin] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [message, setMessage] = useState(null);
  const [controlNumberPNR, setControlNumberPNR] = useState('');
  const [dataSavePNR, setDataSavePNR] = useState(null);
  console.log(",.,.,.,.,., dataSavePNR: ", dataSavePNR)
  const [globalPNR, setGlobalPNR] = useState(null);
  const [modalListPassenger, setModalListPassenger] = useState(false);
  const [dataToEdit, setDataToEdit] = useState(null);

  const stepsList = [
    { id: 1, name: 'Datos Personales', available: false },
    { id: 2, name: 'Verificación de reserva', available: false },
    { id: 3, name: 'Pagar', available: false },
  ]

  function hiddenModalSesion() {
    setNeedLogin(false)
    setTimeout(() => {
      window.location.href = '/';
    }, 1500);
  }

  function goToScreen(screen) {
    setNeedLogin(false)
    const stateProps = {
      routeMemory: window.location.pathname,
      dataMemory: { ...location }
    }
    navigate(screen, { state: stateProps })
  }

  async function savePNR() {
    if (isLoading) return;
    try {
      setIsLoading(true)
      setShowModal(true)
      setModalListPassenger(false)
      const url = 'https://travelflight.pdtcomunicaciones.com/api/savepnr';
      const result = await axios.post(url, dataSavePNR);
      console.log("result PNR");
      console.log({ result });
      if (result) {
        const newMessage = {
          text: "Su vuelo ha sido reservado exitosamente",
          code: result?.data?.reserve?.control_number,
        }
        setMessage(newMessage)
        setControlNumberPNR(result?.data?.reserve?.control_number);
      }
    } catch (error) {
      console.log("Error in savePNR()", error)


      if (error?.response?.data?.status === 400 || error?.response?.status === 500) {
        console.log(" error: ", error?.response?.data)
        setMessage({
          text: "Error al intertar reservar, por favor intente de nuevo", code: 'ERROR',
        })
      }
    }
    finally {
      setIsLoading(false)
    }
  }

  useEffect(() => {
    if (showModal && !isLoading) {
      setTimeout(() => {
        setShowModal(false);
        setMessage(null);
        if (message && message?.code !== "ERROR") {
          setStep(2);
        }
      }, 5000);
    }
  }, [isLoading, showModal]);


  function getSession() {
    console.log("getSession.................")
    console.log('loadingContext:', loadingContext)
    console.log("userDetail: ", userDetail)
    console.log("userToken: ", userToken)
    if (!loadingContext) {
      if (!userToken && !userDetail) {
        console.log("no hay session")
        setNeedLogin(true)
      }
      else {
        console.log("contexto: ", userDetail)
      }
      setLoadingScreen(false)
    }
  }


  function setShowModalClick() {
    setShowModal(false)
    setShowModal(false);
    setMessage(null);
    setStep(2);
  }


  const smoothScrollToTop = () => {
    const currentPosition = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
    if (currentPosition > 0) {
      window.requestAnimationFrame(smoothScrollToTop);
      window.scrollTo(0, currentPosition - currentPosition / 8);
    }
  };


  function getDataToEdit(data) {
    console.log("getDataToEdit: ", data)
    setDataToEdit(data)
    setModalListPassenger(false);
  }


  function showListPassenger(PNR) {
    console.log("pnr recibido desde 1: ", showListPassenger)
    setDataSavePNR(PNR)
    setModalListPassenger(true);
  }

  useEffect(() => {
    smoothScrollToTop();
    if (!location?.refresh) {
      console.log("verificar si existe session");
      getSession()
    }
  }, [])

  return {
    step,
    setStep,
    loadingScreen,
    userDetail,

    userToken,
    needLogin,
    setNeedLogin,
    stepsList,

    hiddenModalSesion,
    goToScreen,
    savePNR,
    isLoading,

    showModal,
    message,
    location,
    setShowModalClick,

    controlNumberPNR,
    globalPNR,
    setGlobalPNR,
    dataSavePNR,
    showListPassenger,
    modalListPassenger,
    getDataToEdit,
    dataToEdit,
    setModalListPassenger
  }
}

export default usePassengerInformationForm;
